var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-bar-wrapper"},[_c('van-submit-bar',{attrs:{"price":_vm.price,"loading":_vm.loading,"disabled":_vm.loading,"button-text":"提交订单"},on:{"submit":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }